export const executeCommands = (...command: (() => void)[]): void => {
  command.forEach((f) => f());
};
